import React, { useState, useEffect } from 'react';
import { $ContactCreate,$ServiceCreate, BillingAccountsVService, $ContactUpdate, $ServiceUpdate, ContactsVService, ServicesVService } from '../../../services/V2/gozer';
import { Address } from '../../shared/Address';
import { TabbedTable } from '../../shared/TabbedTable';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import { AddModal } from '../../shared/AddModal';
import { EditModal } from '../../shared/EditModal';
import { authProvider } from '../../../services/Security';

export const ExtraDetails = ({ loading, setLoading, billingAccountId, style, districtId }) => {
    const [rowData, setRowData] = useState<any>();
    const [canUpdateService, setCanUpdateService] = useState<boolean>(false);
    const [canUpdateContact, setCanUpdateContact] = useState<boolean>(false);
    const [showAddService, setShowAddService] = useState<boolean>(false);
    const [showEditService, setShowEditService] = useState<boolean>(false);
    const [showAddContact, setShowAddContact] = useState<boolean>(false);
    const [showEditContact, setShowEditContact] = useState<boolean>(false);
    //const [relAccounts, setRelAccounts] = useState<any[]>([]);
    const tabColumns = [
        [
            { title: 'Type', field: 'type', editable: 'never' },
            { title: 'Meter Number', field: 'meter.meterNumber', editable: 'never', render: rowData => rowData.meter?.meterNumber },
            { title: 'Meter Type', field: 'meter.type', editable: 'never', render: rowData => rowData.meter?.type },
            { title: 'Address', field: 'serviceaddress.address', editable: 'never', render: rowData => rowData.serviceAddress?.street },
            { title: 'City', field: 'serviceaddress.city', editable: 'never', render: rowData => rowData.serviceAddress?.city },
            { title: 'State', field: 'serviceaddress.state', editable: 'never', render: rowData => rowData.serviceAddress?.state },
            { title: 'Zip', field: 'serviceaddress.zip', editable: 'never', render: rowData => rowData.serviceAddress?.zip }
        ],
        [
            { title: 'First Name', field: 'firstName', editable: 'never' },
            { title: 'Last Name', field: 'lastName', editable: 'never' },
            { title: 'Email', field: 'email', editable: 'never' },
            { title: 'Type', field: 'type', editable: 'never' }
        ],
        [
            { title: 'District', field: 'district', editable: 'never' },
            { title: 'Acconut Number', field: 'accountNumber', editable: 'never' },
            { title: 'Status', field: 'status', editable: 'never' },
            { title: 'Active', field: 'isActive', editable: 'never' }
        ]
    ];
    const tabDetails = [
        [],
        [
            {
                tooltip: 'Address',
                render: rowData => (
                    <Address
                        rowData={rowData.rowData}
                        showName={false}
                    />
                )
            }
        ],
        []
    ]

    const handleShowEditService = (row) => {
        setRowData(row)
        setShowEditService(true);
    }

    const handleShowEditContact = (row) => {
        setRowData(row)
        setShowEditContact(true);
    }

    const tabActions = [
        [
            {
                icon: () => <AddIcon />,
                tooltip: 'Add Service',
                isFreeAction: true,
                onClick: () => setShowAddService(true),
                disabled: !canUpdateService
            },
            {
                icon: () => <EditIcon />,
                tooltip: 'Edit Service',
                onClick: (event, row) => handleShowEditService(row),
                disabled: !canUpdateService
            }
        ],
        [
            {
                icon: () => <AddIcon />,
                tooltip: 'Add Contact',
                isFreeAction: true,
                onClick: () => setShowAddContact(true),
                disabled: !canUpdateContact
            },
            {
                icon: () => <EditIcon />,
                tooltip: 'Edit Contact',
                onClick: (event, row) => handleShowEditContact(row),
                disabled: !canUpdateContact
            }
        ],
        []
    ]

    const tabData = [
        query => {
            return new Promise((resolve, reject) => {
                ServicesVService.servicesVGetAll(billingAccountId, {
                    pageNumber: (query?.page ?? 0) + 1,
                    numberPerPage: query?.pageSize ?? 5,
                    orderBy: query?.orderBy?.field?.toString() ?? "Type",
                    orderByDesc: query?.orderDirection === "desc",
                    filters: []
                }).then((x:any) => {
                    setLoading(false)
                    resolve({
                        data: x.items ?? [],
                        page: query?.page ?? 0,
                        totalCount: x.numberOfItems ?? 0
                    })
                }).catch(x => {
                    reject(x)
                })
            })
        },
        query => {
            return new Promise((resolve, reject) => {
                ContactsVService.contactsVGetAll(billingAccountId, {
                    pageNumber: (query?.page ?? 0) + 1,
                    numberPerPage: query?.pageSize ?? 5,
                    orderBy: query?.orderBy?.field?.toString() ?? "FirstName",
                    orderByDesc: query?.orderDirection === "desc",
                    filters: []
                }).then((x:any) => {
                    setLoading(false)
                    resolve({
                        data: x.items ?? [],
                        page: query?.page ?? 0,
                        totalCount: x.numberOfItems ?? 0
                    })
                }).catch(x => {
                    reject(x)
                })
            })
        },
    ];

    useEffect(() => {
        let perms = authProvider.getPermissions();
        setCanUpdateService(perms.some((perm: string) => perm === "UpdateBillingAccounts"));
        setCanUpdateContact(perms.some((perm: string) => perm === "UpdateBillingAccounts"));
    }, [])

    return (
        <>
            {showAddService &&
                <AddModal
                    setShow={setShowAddService}
                    show={showAddService}
                    setLoading={setLoading}
                    loading={loading}
                    addEndpoint={BillingAccountsVService.billingAccountsVCreate}
                    keys={$ServiceCreate.properties}
                    modelName="Service"
                    parentId={billingAccountId}
                    parentsParentId={null}
                    parent={null}
                    parentValues={[]}
                    canReadUserRoles={false}
                    successMessage={null}
                    successCallback={null}
                    canReadMeters={true}
                    canReadServiceAddresses={true}
                    districtId={districtId}
                />}
            {showEditService &&
                <EditModal
                    modelId={rowData.id}
                    parentId={billingAccountId}
                    parentsParentId={null}
                    data={rowData}
                    modelName="Service"
                    setShow={setShowEditService}
                    setLoading={setLoading}
                    loading={loading}
                    isEdit={true}
                    editEndpoint={ServicesVService.servicesVUpdateService}
                    extraEndpoint={null}
                    deleteEndpoint={ServicesVService.servicesVDelete}
                    viewKeys={null}
                    editKeys={$ServiceUpdate.properties}
                    extraKeys={null}
                    hardDelete={canUpdateService}
                    canReadUserRoles={false}
                    canReadMeters={true}
                    canReadServiceAddresses={true}
                    districtId={districtId}
                />}
            {showAddContact &&
                <AddModal
                    setShow={setShowAddContact}
                    show={showAddContact}
                    setLoading={setLoading}
                    loading={loading}
                    addEndpoint={ContactsVService.contactsVCreate}
                    keys={$ContactCreate.properties}
                    modelName="Contact"
                    parentId={billingAccountId}
                    parentsParentId={null}
                    parent={null}
                    parentValues={[]}
                    canReadUserRoles={false}
                    successMessage={null}
                    successCallback={null}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            {showEditContact &&
                <EditModal
                    modelId={rowData.id}
                    parentId={billingAccountId}
                    parentsParentId={null}
                    data={rowData}
                    modelName="Contact"
                    setShow={setShowEditContact}
                    setLoading={setLoading}
                    loading={loading}
                    isEdit={true}
                    editEndpoint={ContactsVService.contactsVUpdateContact}
                    extraEndpoint={null}
                    deleteEndpoint={ContactsVService.contactsVDelete}
                    viewKeys={null}
                    editKeys={$ContactUpdate.properties}
                    extraKeys={null}
                    hardDelete={canUpdateContact}
                    canReadUserRoles={false}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            <TabbedTable
                tabData={tabData}
                tabColumns={tabColumns}
                tabDetails={tabDetails}
                tabActions={tabActions}
                tabNames={["Services", "Contacts", "Related Accounts"]}
                style={style}
            />
        </>
    );
}